import axios from "axios";
import {
  getData,
  getDataforUrl,
  postRawData,
  postRawDataWithOutToken,
  putRawData,
} from "./index";

export const LoginApi = async (payload) => {
  return postRawDataWithOutToken("user/login", payload).then((data) => {
    //console.log(data);
    return data;
  });
};
export const OTPVerificationApi = async (payload) => {
  return postRawData("user/verify-otp", payload).then((data) => {
    //console.log(data);
    return data;
  });
};
export const UserDetailApi = async (payload) => {
  return getData("user/user-profile", payload).then((data) => {
    // console.log(data?.message);
    // if (data?.message === "jwt malformed") {
    //   localStorage.clear("");
    // }
    return data;
  });
};
export const getAllPackagesListApi = async (payload) => {
  return getData("user/get-all-packages", payload).then((data) => {
    //console.log(data);
    return data;
  });
};
export const EditProfileApi = async (payload) => {
  return putRawData("user/update-profile", payload).then((data) => {
    //console.log(data);
    return data;
  });
};
export const logoutApi = async (payload) => {
  return postRawData("user/logout", payload).then((data) => {
    //console.log(data);
    return data;
  });
};
export const allBookingsListApi = async (payload) => {
  return getData("user/all-bookings", payload).then((data) => {
    //console.log(data);
    return data;
  });
};
export const bookInspectionApi = async (payload) => {
  return postRawData("user/book-inspection", payload).then((data) => {
    //console.log(data);
    return data;
  });
};
export const allPropertiesApi = async (payload) => {
  return getData("user/get-all-properties", payload).then((data) => {
    //console.log(data);
    return data;
  });
};
export const BookingDetailApi = async (payload) => {
  return getData("user/booking-details", payload).then((data) => {
    //console.log(data);
    return data;
  });
};
export const BookingUpdateApi = async (payload) => {
  return putRawData("user/update-booking-details", payload).then((data) => {
    //console.log(data);
    return data;
  });
};
export const AddLeadApi = async (payload) => {
  return postRawData("user/add-lead", payload).then((data) => {
    //console.log(data);
    return data;
  });
};
export const bookingPaymentApi = async (payload) => {
  return postRawData("user/booking-payment", payload).then((data) => {
    //console.log(data);
    return data;
  });
};
